module.exports = __webpack_public_path__ + "img/locations_layout6.06326a69.png";